
export type StoredFileConfig = {
    maxUploadBytes: number
    allowedTypes: AllowedUploadType[]
}

export const DEFAULT_FILE_CONFIG: StoredFileConfig = {
    maxUploadBytes: 25 * 1024 * 1024,
    allowedTypes: [
        { extension: 'pdf', mimetypes: ['application/pdf'] },
        { extension: 'doc', mimetypes: ['application/msword'] },
        { extension: 'docx', mimetypes: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'] },
        { extension: 'odt', mimetypes: ['application/vnd.oasis.opendocument.text'] },
        { extension: 'rtf', mimetypes: ['application/rtf', 'text/rtf'] },
        { extension: 'txt', mimetypes: ['text/plain'] },
        { extension: 'md', mimetypes: ['text/markdown', 'text/plain'] },
        { extension: 'xls', mimetypes: ['application/vnd.ms-excel'] },
        { extension: 'xlsx', mimetypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] },
        { extension: 'ods', mimetypes: ['application/vnd.oasis.opendocument.spreadsheet'] },
        { extension: 'csv', mimetypes: ['text/csv', 'application/vnd.ms-excel', 'text/plain'] },
        { extension: 'ppt', mimetypes: ['application/vnd.ms-powerpoint'] },
        { extension: 'pptx', mimetypes: ['application/vnd.openxmlformats-officedocument.presentationml.presentation'] },
        { extension: 'odp', mimetypes: ['application/vnd.oasis.opendocument.presentation'] },
        { extension: 'json', mimetypes: ['application/json', 'text/plain'] },
        { extension: 'xml', mimetypes: ['application/xml', 'text/xml', 'text/plain'] },
        { extension: 'yaml', mimetypes: ['application/yaml', 'application/x-yaml', 'text/yaml', 'text/x-yaml', 'text/plain'] },
        { extension: 'yml', mimetypes: ['application/yaml', 'application/x-yaml', 'text/yaml', 'text/x-yaml', 'text/plain'] },
        { extension: 'log', mimetypes: ['text/plain', 'text/x-log'] },
        { extension: 'srt', mimetypes: ['application/x-subrip', 'text/srt', 'text/plain', 'application/octet-stream'] },
        { extension: 'ics', mimetypes: ['text/calendar', 'application/ics'] },
        { extension: 'zip', mimetypes: ['application/zip', 'application/x-zip-compressed'] },
        { extension: 'rar', mimetypes: ['application/vnd.rar', 'application/x-rar-compressed', 'application/x-rar'] },
        { extension: 'tar', mimetypes: ['application/x-tar'] },
        { extension: 'gz', mimetypes: ['application/gzip', 'application/x-gzip'] },
    ],
}
